/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import queryString from 'query-string';
import { getTokenRequest } from 'redux/reducers/auth/reducer';
import { getIsAuth, getMerchantId } from 'redux/reducers/auth/selectors';
import { EASSpinner } from 'components/EASSpinner';
import { REDIRECT_URL } from 'services/constants/env';

export const AuthCode: FC = () => {
	// const { xMerchantId } = useParams<{ xMerchantId: string }>();

	const { search } = useLocation();
	const navigateParams = queryString.parse(search);
	const isAuth = useSelector(getIsAuth);
	const merchantIdSelector = useSelector(getMerchantId);

	const navigate = useNavigate();

	const dispatch = useDispatch();

	const urlParams = new URLSearchParams(window.location.search);
	const sessionState = urlParams.get('session_state');

	console.log('AuthCode', sessionState);
	useEffect(() => {
		if (REDIRECT_URL && navigateParams.code && !isAuth) {
			dispatch(
				getTokenRequest({
					code: String(navigateParams.code),
					sessionState: String(navigateParams.session_state),
				}),
			);
		}
	}, [dispatch, navigateParams, merchantIdSelector]);

	useEffect(() => {
		if (isAuth) navigate(`/`);
		// if (isAuth) navigate(`${String(savedUrl ?? '/')}`);
	}, [isAuth, navigate]);

	return <EASSpinner />;
};
